import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { AutoSizer } from 'react-virtualized'
import withStyles from 'beam/dist/styles'
import { ConditionalWrap } from 'beam/dist/utils'
import PlayerPiano from '../../PlayerPiano/PlayerPiano'
import { range } from 'lodash'
import SpeechHitsGraphTape from './SpeechHitsGraphTape'
import { PANEL_SIZES } from '../../MediaPlayer/helpers'

const styles = theme => ({
  confidenceLabel: {
    position: 'absolute',
    zIndex: 1000,
    textAlign: 'center',
    fontSize: '12px',
    height: theme.spacing(2),
    padding: theme.spacing(0, 0.5),
    backgroundColor: 'rgba(250,250,250,0.85)', //Equivalent to theme.palette.grey[50]
    color: theme.palette.grey[400],
  },
})
class SpeechHitsGraph extends Component {
  static propTypes = {
    callDurationMs: PropTypes.number.isRequired,
    audioOffsetMs: PropTypes.number.isRequired,
    speechHits: PropTypes.array,
    t: PropTypes.func,
    classes: PropTypes.object,
    theme: PropTypes.object,
    zoomed: PropTypes.bool,
    currentTime: PropTypes.number,
    setTime: PropTypes.func,
  }

  static defaultProps = {
    t: str => str,
    zoomed: false,
    currentTime: 0,
    setTime: () => {},
  }

  render() {
    const {
      classes,
      theme,
      callDurationMs,
      audioOffsetMs,
      speechHits,
      zoomed,
      currentTime,
      setTime,
    } = this.props

    const eventLanePadding = theme.spacing(1)
    const panelWidth = theme.spacing(PANEL_SIZES.SPEECH)

    return (
      <AutoSizer disableWidth>
        {({ height }) => {
          //If zoomed a pixel every 1/10th of a second
          const graphHeight = zoomed ? Math.max(callDurationMs / 100, height) : height
          const heightUnitsPerMs = graphHeight / callDurationMs
          const getConfidenceLabelPosition = (i, width) => (width - eventLanePadding) * (i / 100) - 2

          return (
            <div style={{ height: `${height}px`, width: `${panelWidth}px` }}>
              <ConditionalWrap
                condition={zoomed}
                wrap={children => (
                  <PlayerPiano
                    duration={callDurationMs}
                    currentTime={currentTime}
                    label={
                      <Fragment>
                        {range(25, 76, 25).map(i => (
                          <div
                            className={classes.confidenceLabel}
                            style={{ left: getConfidenceLabelPosition(i, panelWidth) }}
                            key={i}
                          >
                            {i}
                          </div>
                        ))}
                      </Fragment>
                    }
                  >
                    {children}
                  </PlayerPiano>
                )}
              >
                <SpeechHitsGraphTape
                  width={panelWidth}
                  graphHeight={graphHeight}
                  heightUnitsPerMs={heightUnitsPerMs}
                  callDurationMs={callDurationMs}
                  audioOffsetMs={audioOffsetMs}
                  speechHits={speechHits}
                  zoomed={zoomed}
                  setTime={setTime}
                />
              </ConditionalWrap>
            </div>
          )
        }}
      </AutoSizer>
    )
  }
}

export { SpeechHitsGraph as UnstyledSpeechHitsGraph }

export default withStyles(styles, { withTheme: true })(SpeechHitsGraph)
